export default __webpack_public_path__ + "static/media/banner.17e0c52c.webp";